import { gatewayFetch } from './gateway.js';

export async function createBooking(bookingData) {
  const customerName = String(bookingData.customerName || '').trim();
  const customerEmail = String(bookingData.customerEmail || '').trim().toLowerCase();
  const customerPhone = String(bookingData.phone || bookingData.customerPhone || '').trim();
  const jobAddress = String(bookingData.address || bookingData.jobAddress || '').trim();

  if (!customerName || !customerEmail || !customerPhone) {
    throw new Error('Name, Email, and Phone number are required.');
  }

  if (!jobAddress || !bookingData.scheduledDateTime) {
    throw new Error('Property address and scheduled slot are required.');
  }

  const items = (bookingData.items || []).map(i => ({
    service_name: i.service_name || i.name,
    quantity: Number(i.quantity) || 1.0
  }));

  if (items.length === 0) {
    throw new Error('Please select at least one service item.');
  }

  const payload = {
    customer_name: customerName,
    customer_email: customerEmail,
    customer_phone: customerPhone,
    job_address: jobAddress,
    requested_date: bookingData.scheduledDateTime,
    job_description: bookingData.jobDescription?.trim() || 'Quick Booking Request',
    items
  };

  return await gatewayFetch('/api/v1/public/bookings/request', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export async function getAvailabilityData() {
  try {
    const res = await gatewayFetch('/api/v1/public/availability/').catch(() => ({}));
    const rawBlocked = res.blocked_dates || res.unavailableDates || [];
    return { blockedDates: Array.from(new Set(rawBlocked)) };
  } catch (err) {
    console.error('Error fetching public availability:', err);
    return { blockedDates: [] };
  }
}

export async function getClientBookingsData() {
  const { blockedDates } = await getAvailabilityData();
  return { jobs: [], blockedDates };
}

/**
 * Triggers the 50% deposit automation workflow in n8n.
 * Uses the proven production route and payload schema.
 */
export async function triggerBookingDeposit(bookingId, customerEmail) {
  if (!bookingId || !customerEmail) return;

  return await gatewayFetch(`/api/v1/public/bookings/${bookingId}/deposit`, {
    method: 'POST',
    body: JSON.stringify({
      booking_id: Number(bookingId),
      customer_email: String(customerEmail).trim().toLowerCase()
    })
  });
}